import { el } from "./dom.js";
import { navigate } from "../main.js";
import { MAG } from "../utils/magazine.js";

// Magazine [ Search | Browse ] pill toggle — two modes of the same "find a game
// to add" flow. Active segment = solid lime; inactive = muted, navigates.
export function discoverTabs(active) {
	const tab = (id, label, path) => {
		const on = active === id;
		return el("button", {
			type: "button",
			onclick: on ? undefined : () => navigate(path),
			style: {
				flex: "1", textAlign: "center", border: "0",
				cursor: on ? "default" : "pointer",
				fontFamily: "'Archivo', sans-serif", fontWeight: on ? "900" : "800",
				fontSize: "11px", letterSpacing: ".06em", textTransform: "uppercase",
				color: on ? "#0b0b0f" : MAG.dim, background: on ? MAG.lime : "transparent",
				borderRadius: "999px", padding: "9px 0",
			},
		}, label);
	};
	return el("div", {
		style: {
			display: "flex", background: MAG.bgGlass, border: `1px solid ${MAG.line}`,
			borderRadius: "999px", padding: "4px", margin: "12px 0 0",
			backdropFilter: "blur(12px)", webkitBackdropFilter: "blur(12px)",
		},
	}, tab("search", "Search", "/games/add"), tab("browse", "Browse", "/games/browse"));
}
